import { supplierIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const SupplierProductSkuImportRow = z.object({
  internalSku: z.string().trim().min(1),
  supplierSku: z.string().trim().min(1),
});

export const importSupplierProductSkus = {
  name: "importSupplierProductSkus" as const,
  input: z.object({
    supplierId: supplierIdFormat.schema,
    rows: z.array(SupplierProductSkuImportRow).min(1),
  }),
  output: z.object({
    importedCount: z.number().int(),
    missingInternalSkus: z.array(z.string()),
    duplicateInternalSkus: z.array(z.string()),
  }),
};
